import { helper } from '@ember/component/helper';

import { one } from 'rise-ui/utils/choice.js';

export default helper(function oneHelper(params) {
  return one(...params);
});
